/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Values: 0=CO2, 1=ESG, 2=CSRD, 3=SFDR, 4=CSOB, 5=PROCUREMENT_BUYER, 6=PROCUREMENT_SUPPLIER, 7=GM_ADMIN, 8=T_MOBILE, 9=PROCUREMENT_SUPPLIER_T_MOBILE, 10=PSAS, 11=BRSR, 12=VSME, 13=CSOB_SK, 14=PAYGAP, 15=EF_MANAGEMENT
 * @export
 * @enum {number}
 */

export enum ApplicationFeature {
    CO2 = 0,
    ESG = 1,
    CSRD = 2,
    SFDR = 3,
    CSOB = 4,
    PROCUREMENT_BUYER = 5,
    PROCUREMENT_SUPPLIER = 6,
    GM_ADMIN = 7,
    T_MOBILE = 8,
    PROCUREMENT_SUPPLIER_T_MOBILE = 9,
    PSAS = 10,
    BRSR = 11,
    VSME = 12,
    CSOB_SK = 13,
    PAYGAP = 14,
    EF_MANAGEMENT = 15
}


